import React from 'react';
import CanvasAction from 'components/Actions/CanvasAction';
import actionArray from 'data/tools';

import { Handle, Position } from 'reactflow';

const handleStylesRight = {
  height: 15,
  width: 15,
  right: -20,
  backgroundColor: '#ffffff',
  border: '1px solid rgba(113, 113, 121, 1)',
};

const handleStylesLeft = {
  height: 15,
  width: 15,
  left: -20,
  backgroundColor: '#ffffff',
  border: '1px solid rgba(113, 113, 121, 1)',
};

const FilterNode = (data) => {
  const { category, tooltip, text, icon, description } = actionArray.filter(
    (tool) => tool.name === data.data.configuration.tool_type
  )[0];
  const status = data.data.status;
  const selected = data.selected;
  const error_message = data?.errorMessage;
  const annotation = localStorage.getItem('annotations') == 'True';
  const configured = data.data.configured;

  return (
    <div>
      <CanvasAction
        data={data}
        desc={error_message || tooltip}
        icon={icon}
        name={text}
        category={category}
        status={status}
        selected={selected}
        description={annotation ? description(configured, data.data.configuration) : undefined}
      />
      <Handle type="source" position={Position.Right} style={handleStylesRight} />
      <Handle
        className="hover:!bg-zinc-200"
        type="target"
        position={Position.Left}
        id="dataframe"
        style={handleStylesLeft}
      />
    </div>
  );
};

export default FilterNode;
